export default __webpack_public_path__ + "static/media/ES Influencer Marketing Management.6628b55d.jpg";